import { render } from "./company-roles.vue?vue&type=template&id=6132b482&scoped=true"
import script from "./company-roles.vue?vue&type=script&lang=js"
export * from "./company-roles.vue?vue&type=script&lang=js"

import "./company-roles.vue?vue&type=style&index=0&id=6132b482&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6132b482"]])

export default __exports__